import { render, staticRenderFns } from "./BFooter.vue?vue&type=template&id=f9eb535c&scoped=true"
import script from "./BFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BFooter.vue?vue&type=style&index=0&id=f9eb535c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9eb535c",
  null
  
)

export default component.exports